
import './App.css';
import Weather from './Weather';
function App() {
  return (
    <div className="App">
      <div className='container'>
      <Weather defaultCity="Casablanca"/>
    <footer>
      This project was coded by Wissal Kadiri and is {" "}
      <a href="https://github.com/wissalkadiri/last-weather-app" rel="noreferrer" target="_blank">open-sourced on GitHub </a>
    </footer></div></div>
  );
}

export default App;
